// Angular Environments: https://angular.dev/tools/cli/environments
export interface Environment {
    production: boolean;
    BACKEND_ORIGIN: string;
    GA: string;
}

export const baseEnvironment: Environment = {
    production: false,
    BACKEND_ORIGIN: "https://dev-canvas.eqsuite.com",
    GA: "G-Z9EXMZP0C6",
};
